export default __webpack_public_path__ + "static/media/lock.f582f545.svg";